import React from 'react';
import styled from 'styled-components';

import { dollarsNoCentsWithSymbol, dollarsWithCentsWithSymbol } from 'helpers/currency';
import { FlexCol, FlexJustifySpaceBetween } from 'components/primitives/flex';
import { transformBreakLineDescription } from 'components/add-ons/helpers';
import { BookingAddonItemType } from './types';

type Props = BookingAddonItemType;

export const BookingAddonItem = ({ title, amount, price, rate, description }: Props) => {
  const basePrice = dollarsNoCentsWithSymbol(price);
  const totalPrice = dollarsWithCentsWithSymbol(amount * price);

  return (
    <Wrapper gap="15px">
      <Content gap="6px">
        <Heading>{title}</Heading>
        <Text>
          {amount} x {basePrice} / {rate}
        </Text>
        {description && <Text>{transformBreakLineDescription(description)}</Text>}
      </Content>

      <Price>{totalPrice}</Price>
    </Wrapper>
  );
};

const Wrapper = styled(FlexJustifySpaceBetween)``;

const Content = styled(FlexCol)``;

const Heading = styled.p`
  font-weight: 600;
  margin-bottom: 0;
`;

const Text = styled.p`
  font-size: 15px;
  line-height: 1.3;
  margin-bottom: 0;
`;

const Price = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0;
  flex-basis: 20%;
  text-align: right;
`;
